export default {
  header: {
    dark: "Thème sombre",
    light: "Thème clair",
    system: "Thème du navigateur",
    environment: "Vous travaillez sur l'environnement de test",
    notification: {
      label: "Notifications des traitements",
      status_processing: "Traitement en cours",
      status_success: "Traitement terminé, votre fichier est prêt",
      status_error: "Le traitement a échoué",
      status_unknown:
        "Suivi interrompu : le traitement est peut-être toujours en cours côté serveur, mais votre navigateur ne peut plus vous le confirmer.",
      status_announcement: "{label} : {status}",
      empty: "Aucun traitement en cours...",
      waiting: "En attente d'informations sur le traitement",
      list: "Voir tout l'historique",
      load_more: "Afficher plus",
      historic: "Historique des traitements",
      download: "Télécharger",
      file: "Votre fichier",
    },
  },
  menu: "Menu",
  dashboard: {
    presentation: "Présentation",
    contact: "Contact",
    partner: "Partenaires",
    communication: "Communication",
    timeline: "Timeline",
    timeline_actions: {
      delete: {
        confirmation: "Êtes-vous sûr de vouloir supprimer cette ligne ?",
        success: "Ligne supprimée avec succès !",
      },
    },
    indicator: "Indicateurs",
    indicators: {
      see_details: "Voir le détail des taux de remplissage",
      see_details_complete_triad: "Taux de trinômes complets",
      fill_rate: "Taux de remplissage",
    },
    shared_docs: "Documents partagés",
    registration: "Inscriptions",
    registration_apprentice: "Espace inscription (apprenti)",
    welcome_to_studea: "Bienvenue sur votre portail Studea !",
    welcome_to_dashboard: "Bienvenue sur votre tableau de bord",
    your_actually_are: "Vous êtes actuellement",
    // ST143-TI-17771 (b2): plain placeholder, no embedded HTML — the <strong> wrapping is done by <i18n-t>'s
    // "name" slot in HeaderComponent.vue, as real DOM markup, not by string concatenation.
    welcome_message: "Bienvenue {name} sur votre portail Studea !",
    no_training_course_archived: "Aucune promotion archivé",
    no_training_course_actived: "Aucune promotion active",
    no_triad: "Aucun trinôme",
    triad_search_placeholder: "Rechercher un utilisateur",
    triad_members: "Membres du trinôme",
    questionnaires_empty: "Aucun questionnaire à renseigner",
    contract: {
      company_sheet: "Fiche entreprise",
      type: "Type de contrat :",
      company: "Employeur :",
      dates: "Dates du contrat :",
      rupture_date: "Date de rupture",
      rupture_cause: "Motif de rupture",
      siret: "Siret :",
      address: "Adresse :",
      from: "Du",
      to: "au",
      by: "par",
      secondary: "secondaire",
      reference_contract: "Contrat de référence",
      vised_cerfa: "CERFA visé",
      mission_file: "Fiche mission",
      rupture_justificative: "Fichier de justification",
      rupture_invalidtion_confirmation: "Êtes-vous sûr de vouloir annuler la validation de cette rupture de contrat ?",
      rupture_declared: "Rupture déclarée le",
      rupture_validated: "Valider la rupture",
      rupture_invalidate: "Invalider la rupture",
      invalidate: "Invalider",
      date_overlaps:
        "Certaines dates de contrats se chevauchent, veuillez enregistrer la rupture du contrat précédent ou vérifier les dates saisies dans les contrats",
      no_active_contract_mission:
        "Aucun contrat n'est présent sur ce trinôme. Veuillez en ajouter un pour pouvoir ajouter des missions.",
      no_active_contract_activity:
        "Aucun contrat n'est présent sur ce trinôme. Veuillez en ajouter un pour pouvoir ajouter des activités.",
    },
    training: {
      triad_list: "Voir la liste des trinômes",
    },
    archived_training_course: ({ plural, named }) =>
      plural([`Voir les ${named("label")}s archivées`, `Voir les ${named("label")}s archivés`]),
    unarchived_training_course: ({ plural, named }) =>
      plural([`Voir les ${named("label")}s actives`, `Voir les ${named("label")}s actifs`]),
    Download_the_booklet: "Télécharger le livret",
    Download_the_booklet_with_documents: "Télécharger le livret avec ses documents",
    Download_key_dates: "Télécharger les dates clés",
    session_lock: "Cette session n'est pas encore ouverte à la saisie.",
    skill_lock:
      "Vous ne pouvez pas modifier \ncette compétence qui est \ncalculée par vos réponses aux \nquestionnaires ou qui ne vous \nest pas affectée",
    driverLicence: {
      config: "Gestion des aides permis B",
      confirmation_send: "Le pilote rattaché à votre dossier a été notifié de votre demande.",
      progress: {
        paymentDate: "Date de paiement",
        requestDate: "Date de la demande",
        transmissionDate: "Date de transmission au service financier",
        validationDate: "Date de validation",
      },
    },
    skill: {
      rate_by_profil: "Taux de remplissage des complétences par profil",
    },
  },
  driver_licence: {
    info: "Votre dossier sera envoyé lorsque toutes les pièces jointes seront déposées",
  },
};
